import React from "react";
import Box from "@mui/material/Box";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import IconButton from "@mui/material/IconButton";

import { neutral } from "../../../../common/config/colors";

const LeftButton: React.FC<any> = ({ onClick, ...rest }) => {
  return (
    <Box sx={{ position: "absolute", left: 0 }}>
      <IconButton
        onClick={onClick}
        size="small"
        sx={{
          p: { xs: 0, md: 1 },
          color: neutral["A500"],
          background: "rgba(0,0,0,0.5)",
          "&:hover": {
            background: "rgba(0,0,0,0.5)",
          },
        }}
      >
        <ChevronLeftIcon />
      </IconButton>
    </Box>
  );
};

export default LeftButton;
